import { render, staticRenderFns } from "./ddmCategory.vue?vue&type=template&id=390b995c&scoped=true&"
import script from "./ddmCategory.vue?vue&type=script&lang=js&"
export * from "./ddmCategory.vue?vue&type=script&lang=js&"
import style0 from "./ddmCategory.vue?vue&type=style&index=0&id=390b995c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b995c",
  null
  
)

export default component.exports